import { Component, Inject, OnInit, forwardRef, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';

@Component({
    selector: 'app-delete-system-user-dialog',
    templateUrl: './delete-system-user-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [MatCardModule, MatDialogModule, MatListModule, TranslateModule]
})
export class DeleteSystemUserDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<DeleteSystemUserDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
